<template>
    <v-container>
        <v-layout>
            <v-flex xs4 md3>
                <!--filtro-->
                <v-layout mb-3>
                    <v-flex>
                        <v-menu content-class="menu-card mt-2 app-content flex"
                                min-width="450px"
                                transition="scale-transition"
                                :close-on-content-click="false"
                                offset-y
                                full-width
                                v-model="popupFiltro">
                            <v-btn slot="activator" class="btn-default" color="dark" large outline>
                                <v-icon color="primary">lnr-funnel</v-icon>
                                <div class="pl-1">Filtrar</div>
                            </v-btn>
                            <v-layout column class="card">
                                <v-layout row wrap>
                                    <v-flex mr-3>
                                        <v-label>Início</v-label>
                                        <v-text-field ref="textField"
                                                      v-model="dadosFiltro.dash_data_ini"
                                                      flat
                                                      solo
                                                      validate-on-blur
                                                      mask="##/##/####"
                                                      return-masked-value
                                                      :rules="[rules.date]">
                                        </v-text-field>
                                    </v-flex>

                                    <v-flex ml-3>
                                        <v-label>Fim</v-label>
                                        <v-text-field ref="textField"
                                                      v-model="dadosFiltro.dash_data_fim"
                                                      flat
                                                      solo
                                                      validate-on-blur
                                                      mask="##/##/####"
                                                      return-masked-value
                                                      :rules="[rules.date]">
                                        </v-text-field>
                                    </v-flex>
                                </v-layout>

                                <v-layout row wrap>
                                    <v-flex>
                                        <v-label>Título do comunicado</v-label>
                                        <v-text-field ref="textField"
                                                      v-model="dadosFiltro.titulo"
                                                      flat
                                                      solo>
                                        </v-text-field>
                                    </v-flex>
                                </v-layout>

                                <v-layout row wrap>
                                    <v-flex>
                                        <v-label v-if="dadosFiltro.tipo !== ''">Tipo do comunicado</v-label>
                                        <v-select :items="items_tipo"
                                                  item-text="text"
                                                  item-value="id"
                                                  v-model="dadosFiltro.tipo"
                                                  label="Tipo do comunicado"
                                                  flat
                                                  solo
                                        ></v-select>
                                    </v-flex>
                                </v-layout>

                                <v-layout mt-3 justify-center>
                                    <v-flex xs4>
                                        <v-btn class="btn-default" color="dark" outline @click="limpar">Limpar</v-btn>
                                    </v-flex>
                                    <v-flex xs4>
                                        <v-btn class="btn-default primary" @click="filtrar">Filtrar</v-btn>
                                    </v-flex>
                                </v-layout>
                            </v-layout>
                        </v-menu>
                    </v-flex>
                    <v-flex>
                        <v-btn class="btn-default" color="primary" large :to="{name:'cadastro_comunicado'}">
                            Cadastrar
                        </v-btn>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
        <!--listagem-->
        <v-layout column class="card table">
            <data-table ref="table" url="/admin/comunicados" :filter="dtFiltro" :headers="headers">
                <template slot="items" slot-scope="{ item }">
                    <td>{{ item.data_hora_publicacao | moment}}</td>
                    <td class="text-capitalize">{{ item.titulo }}</td>
                    <td>{{ getDescTipoDocumento(item.tipo_conteudo).desc }}</td>
                    <td class="text-truncate">{{ item.texto | sub }}</td>
                    <td>
                        <v-layout>
                            <v-btn :disabled="isEditable(item.data_hora_publicacao)" flat icon color="primary" @click="editar(item)">
                                <v-icon>ol-edit</v-icon>
                            </v-btn>
                            <v-btn flat icon color="primary" @click="excluir(item)">
                                <v-icon>ol-delete</v-icon>
                            </v-btn>
                        </v-layout>
                    </td>
                </template>
            </data-table>
        </v-layout>
    </v-container>
</template>

<script>
import DataTable from '../components/DataTable'
import { alert, error, sleep } from '../plugins/helpers'
import moment from 'moment'
import Rules from '../plugins/validation'

/**
 * @var item
 * @type {object}
 * @property {number} id_unidade_negocio
 * @property {string} codigo
 * @property {string} nome
 */

export default {
  components: { DataTable },
  data: () => ({
    headers: [
      { text: 'Data publicação', value: 'data_hora_publicacao' },
      { text: 'Título', value: 'titulo' },
      { text: 'Tipo de conteúdo', value: 'tipo_conteudo' },
      { text: 'Texto', value: 'texto' },
      { value: '', sortable: false }
    ],
    items_tipo: [
      { text: 'texto', id: 'texto', desc: 'Texto' },
      { text: 'imagem', id: 'imagem', desc: 'Imagem' },
      { text: 'pdf', id: 'pdf', desc: 'Pdf' },
      { text: 'vídeo', id: 'video', desc: 'Vídeo' }
    ],
    dadosFiltro: {
      titulo: '',
      tipo: ''
    },
    dtFiltro: {},
    popupFiltro: false
  }),
  computed: {
    rules: () => Rules
  },
  filters: {
    sub: (value) => value ? value.substring(0, 30) + '...' : '',
    moment: function (date) {
      return moment(date).format('DD/MM/YYYY HH:mm:ss')
    }
  },
  watch: {
    popupFiltro (open) {
      if (open) {
        sleep(100).then(() => this.$refs.textField.focus())
      }
    }
  },
  methods: {
    editar (item) {
      this.$router.push({ name: 'cadastro_comunicado', params: { id_comunicado: `${item.id_comunicado}` } })
    },
    excluir (item) {
      let excluir = false

      if (moment(item.data_hora_publicacao, 'YYYY-MM-DD HH:mm:ss').isAfter(moment())) {
        excluir = true
      }

      if (excluir) {
        alert({
          text: `Tem certeza que deseja excluir o comunicado${item.titulo ? ' ' + item.titulo : ''}?`,
          buttons: {
            'Cancelar': () => true,
            'Excluir': () => {
              this.$http.delete(`/admin/comunicados/${item.id_comunicado}`).then(() => {
                alert(`Comunicado excluído com sucesso!`)
                this.dtFiltro = { ...this.filtro }
              }).catch(err => {
                error(err, 'Não foi possível excluir o comunicado.')
              })
            }
          }
        })
      } else {
        alert('Data de publicação já passou. Não é possível excluir o comunicado.')
      }
    },
    filtrar () {
      this.popupFiltro = false
      this.dtFiltro = { ...this.dadosFiltro }
    },
    limpar () {
      this.dadosFiltro.dash_data_fim = ''
      this.dadosFiltro.dash_data_ini = ''
      this.dadosFiltro.nome = ''
      this.dadosFiltro.items_tipo = ''
      this.dadosFiltro.tipo = ''
      this.dadosFiltro.titulo = ''
      this.filtrar()
    },
    isEditable (date) {
      return moment(date, 'YYYY-MM-DD HH:mm:ss').isBefore(moment())
    },
    getDescTipoDocumento (tipo_documento) {
      return this.items_tipo.find((s) => s.id === tipo_documento) || {}
    }
  }
}
</script>

<style scoped>
</style>
